import { FormDropdown } from './DropDowns/FormDropdown'
import { AssetServiceTypeDropdown } from './DropDowns/AssetServiceTypeDropdown'
import { AssetTypeDropdown } from './DropDowns/AssetTypeDropdown'
import { renderFormSubmit } from './Buttons/RenderFormSubmit'
import { AssetCategoriesDropdown } from './DropDowns/AssetCategoriesDropdown'
import { useRecoilState } from 'recoil'
import { formTypeAtom } from '../../../../State/Atoms/FormProps/FormPropsAtoms'
import { assetCategoriesAtom } from '../../../../State/Atoms/AssetData/AssetDataAtoms'
import { useEffect } from 'react'
import Cookies from 'universal-cookie'
import { getBaseURL } from '../../../../../GlobalComponents/URLs'

const NewFormChoices = () => {
    // new form choices are only rendered if the formType path is used
    const [formType] = useRecoilState(formTypeAtom)
    const [assetCategories, setAssetCategories] = useRecoilState(assetCategoriesAtom)
    useEffect(() => {
        if (!assetCategories || assetCategories.length === 0) {
            const cookies = new Cookies(document.cookie)
            let cacheKey = `assetCategories${cookies.get('CoRoot')}`
            if (
                localStorage.getItem(cacheKey) &&
                localStorage.getItem(cacheKey) !== 'false' &&
                localStorage.getItem(cacheKey) !== 'null'
            ) {
                setAssetCategories(JSON.parse(localStorage.getItem(cacheKey)))
            } else {
                fetch(`${getBaseURL()}webapi/form/asset/categories`, {
                    credentials: 'include',
                })
                    .then((response) => {
                        return response.json()
                    })
                    .then((json) => {
                        setAssetCategories(json)
                    })
            }
        }
    }, [])
    return (
        <div
            style={{
                textAlign: 'center',
                paddingTop: '100px',
                width: '100%',
            }}
        >
            <AssetCategoriesDropdown />
            <AssetTypeDropdown />
            <AssetServiceTypeDropdown />
            <FormDropdown />
            {renderFormSubmit()}
        </div>
    )
}

export default NewFormChoices
